import { API_URL, SERVER_URL } from '../../configs/env.config';

export const API_HOST = API_URL;

// 1 second of visibility on the video would at minimum equals to 10px
export const minWidth = 10;

export const secondToMilisecond = 1000;

export const showTimeDefault = 1000;

export const initTimeDefault = 4000;

// timeline rectange width default
export const widthDefault = 10;

export const marginShowCursorResize = 10;

export const SCROLL_WIDTH = 15;

export const VERSION = '1.0.0';

export const BEGIN_FETCH_DATA = 'BEGIN_FETCH_DATA';

export const FINISH_FETCH_DATA = 'FINISH_FETCH_DATA';

export const SAVE_STATE = 'SAVE_STATE';

export const SAVE_CONTENT_REQUEST = 'content/SAVE_CONTENT_REQUEST';
export const SAVE_CONTENT_SUCCESS = 'content/SAVE_CONTENT_SUCCESS';

// export const SERVER_HOST = 'http://localhost:3030/api/v1';

export const SERVER_HOST = SERVER_URL;



// WEBPACK FOOTER //
// ./src/containers/content/constant.js